import React from "react";
import { Col, Row, Form, Checkbox, Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

import "../style.css";
import { useDispatch, useSelector } from "react-redux";
import { setPrioritySelections } from "../../../Redux/filterSlice";
import { allPriorities } from "../../../Common/constants";

const CheckboxGroup = Checkbox.Group;
let CurrentIndex = 0;
function Step3() {
  const dispatch = useDispatch();
  const prioritySelections = useSelector(
    (state) => state.filter.prioritySelections
  );

  const renderHeading = (index) => {
    let toReturn = null;
    switch (index) {
      case 0:
        toReturn = "Soil";
        break;
      case 4:
        toReturn = `Water`;
        break;
      case 8:
        toReturn = `Wildlife`;
        break;
      case 14:
        toReturn = `Ecosystem Benefits`;
        break;
      default:
        break;
    }
    return toReturn;
  };

  return (
    <>
      <Row>
        <Col span={24} className="mt-3">
          <div>
            <b>
              3) Which conservation priorities would you like to address the
              most?
            </b>
          </div>
        </Col>
      </Row>
      <Form>
        <Row gutter={40} className="mt-3 checkbox-list">
          <CheckboxGroup
            className="checkbox-group priority-sel-tutorial"
            onChange={(checkedValues) =>
              dispatch(setPrioritySelections(checkedValues))
            }
            defaultValue={prioritySelections}
          >
            {allPriorities.map((priority, index) => {
              CurrentIndex = index;
              return (
                <>
                  <h1
                    className={renderHeading(CurrentIndex) ? "typeHeading" : ""}
                  >
                    {renderHeading(CurrentIndex)}
                  </h1>
                  <Checkbox
                    className="checkbox-container"
                    value={priority.value}
                  >
                    <img
                      className="checkbox-image"
                      src={priority.src}
                      alt={priority.alt}
                    />
                    <Popover
                      overlayStyle={{
                        maxWidth: "20vw",
                      }}
                      placement="topRight"
                      content={priority.qContent}
                      trigger="hover"
                    >
                      <span className="pa">
                        <QuestionCircleOutlined />
                      </span>
                    </Popover>
                    <div className="checkbox-label">{priority.label}</div>
                  </Checkbox>
                </>
              );
            })}
          </CheckboxGroup>
        </Row>
      </Form>
    </>
  );
}
export default Step3;
